
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MagazineCardSeriesContent',
  props: {
    wide: Boolean,
    image: {
      type: String,
      default: require('@/assets/images/common/noimg.jpg')
    },
    imageAlt: {
      type: String,
      default: ''
    },
    title: String,
    date: String,
    category: {
      type: String,
      default: ''
    },
    description: String
  },
  setup(props) {
    const headingClass = {
      magazineCard_heading: !props.wide,
      magazineCard_heading_wide: props.wide
    }

    return {
      headingClass
    }
  }
})
